// extracted by mini-css-extract-plugin
export default {"container":"JF-z","innerContainer":"KF-z","multipleLines":"LF-z","heading":"MF-z","content":"NF-z","linkColor":"OF-z"};